"use client";
import { getProductNavigationUrl } from "../../productService/lib.js";
import { getCompareProductButtonData, getReviewRatingData, getReplacementItemNumber, getProductImageUrl, getProductDeliveryBadgeData, getProductActions, getPriceData, getPillBadges, getIsFsaEligible, getIsChdiEligible, getDeliveryChannelBadgeData, getColorSwatchesData, getAvailabilityInfoData, getAddToListButtonData } from "./lib.js";
import { normalizeGRSPharmacyData } from "./normalizeGRSPharmacyData.js";
import { normalizeGRSTravelData } from "./normalizeGRSTravelData.js";
import { isFeatureEnabledForApplication } from "../../../utils/contentstack/lib.js";
const normalizeGRSData = (grsData, productConfig, hasUserSignedId, cookieContext, showMultiVariantsAvailability) => {
  const {
    pillBadgeConfig,
    imageConfig,
    featureToggleConfig,
    enabledWarehousesListConfig,
    translationsConfig
  } = productConfig || {};
  const normalizedData = grsData == null ? void 0 : grsData.map(
    (item) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
      const { id, product, variantRollupValues } = item || {};
      if ((_b = (_a = product.attributes.product_type) == null ? void 0 : _a.text) == null ? void 0 : _b.includes("TRAVEL")) {
        return normalizeGRSTravelData(item);
      }
      if ((_d = (_c = product.attributes.product_type) == null ? void 0 : _c.text) == null ? void 0 : _d.includes("PHARMACY")) {
        return normalizeGRSPharmacyData(item, translationsConfig);
      }
      const hasLinkFee = Boolean(item.inventory.hasLinkFee) || false;
      return {
        addToListButtonData: getAddToListButtonData(
          item,
          cookieContext
        ),
        availabilityInfoData: getAvailabilityInfoData(
          item,
          enabledWarehousesListConfig,
          featureToggleConfig,
          cookieContext,
          showMultiVariantsAvailability
        ),
        colorSwatchesData: getColorSwatchesData(
          item,
          imageConfig,
          featureToggleConfig
        ),
        deliveryChannelData: {
          status: getDeliveryChannelBadgeData(item, cookieContext)
        },
        isChdiEligible: getIsChdiEligible(item),
        isEcoFeeEligible: Boolean(hasLinkFee),
        isFsaEligible: getIsFsaEligible(item),
        isMemberOnlyItem: !!((_e = item.variantRollupValues["attributes.member_only"]) == null ? void 0 : _e[0]),
        isPublished: true,
        pillBadges: getPillBadges(
          (_f = item.product.attributes.pills) == null ? void 0 : _f.text,
          pillBadgeConfig,
          imageConfig == null ? void 0 : imageConfig.domainUrl
        ),
        priceListData: getPriceData(item, cookieContext),
        productActions: getProductActions(
          item,
          featureToggleConfig,
          hasUserSignedId,
          cookieContext
        ),
        productDeliveryBadgeData: getProductDeliveryBadgeData(
          item,
          translationsConfig,
          imageConfig == null ? void 0 : imageConfig.domainUrl
        ),
        productInfoData: {
          itemNumber: ((_g = variantRollupValues.variantId) == null ? void 0 : _g[0]) || "",
          partNumber: id,
          productBrand: ((_h = product.attributes.product_type) == null ? void 0 : _h.text) || "",
          productImageUrl: getProductImageUrl(item),
          productLinkUrl: getProductNavigationUrl(
            product.title,
            id,
            imageConfig == null ? void 0 : imageConfig.domainUrl,
            void 0,
            void 0,
            (_i = featureToggleConfig == null ? void 0 : featureToggleConfig.enableBModPDPNavigationUrl) == null ? void 0 : _i.isEnabled
          ),
          productName: product.title,
          replacementItemNumber: getReplacementItemNumber()
        },
        savingsData: {
          priceInCartOnly: ((_l = (_k = (_j = item == null ? void 0 : item.product) == null ? void 0 : _j.attributes) == null ? void 0 : _k.disp_price_in_cart_only.numbers) == null ? void 0 : _l[0]) !== 2,
          bundle: ((_p = (_o = (_n = (_m = item == null ? void 0 : item.product) == null ? void 0 : _m.attributes) == null ? void 0 : _n.product_type) == null ? void 0 : _o.text) == null ? void 0 : _p[0]) === "bundle",
          salePrice: (_q = item == null ? void 0 : item.inventory) == null ? void 0 : _q.deliveryPrice,
          listPrice: (_r = item == null ? void 0 : item.inventory) == null ? void 0 : _r.originalPrice,
          freightSavingsEnabled: isFeatureEnabledForApplication(
            (_s = featureToggleConfig.freightSavings) == null ? void 0 : _s.featureOn,
            (_t = featureToggleConfig.freightSavings) == null ? void 0 : _t.enabledApplications
          )
        },
        promoItem: {
          promoText: (_v = (_u = product.attributes.marketing_statement) == null ? void 0 : _u.text) == null ? void 0 : _v[0],
          promoTextColor: ""
        },
        reviewRatingData: getReviewRatingData(item, translationsConfig),
        showCompareProductButton: getCompareProductButtonData(item)
      };
    }
  );
  return normalizedData;
};
export {
  normalizeGRSData
};
